import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 숫자를 천 단위로 구분하여 포맷팅합니다.
 * @param value 포맷팅할 숫자
 * @returns 천 단위로 구분된 문자열
 */
export function formatNumber(value: number): string {
  return value.toLocaleString('ko-KR');
}


/**
 * 값이 비어있거나, 의미 없는 문자열("string", "null", "none", "없음")인지 확인합니다.
 * @param value 확인할 값
 * @returns 비어있거나 의미 없는 값이면 true, 아니면 false
 */
export const isEmptyFieldValue = (value: string | null | undefined): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  const lowercasedValue = value.toLowerCase().trim();
  return lowercasedValue === '' || lowercasedValue === 'string' || lowercasedValue === 'null' || lowercasedValue === 'none' || lowercasedValue === '없음';
};


/**
 * 전화번호 형식(하이픈 추가 등)을 정리합니다.
 * @param phone 원본 전화번호 문자열
 * @returns 정리된 전화번호 문자열
 */
export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) {
    return '';
  }

  // 하이픈, 점, 공백 제거
  const cleanPhone = phone.replace(/[-.\s]/g, '');

  if (/^\d+$/.test(cleanPhone)) {
    // 숫자로만 이루어진 경우
    if (cleanPhone.length === 11 && cleanPhone.startsWith('010')) {
      return `${cleanPhone.slice(0, 3)}-${cleanPhone.slice(3, 7)}-${cleanPhone.slice(7)}`;
    }
    if (cleanPhone.length === 8) {
      return `010-${cleanPhone.slice(0, 4)}-${cleanPhone.slice(4)}`;
    }
  } else if (phone.includes('-') && !phone.startsWith('010')) {
    // 이미 하이픈이 있고 010으로 시작하지 않는 경우 (예: 2988-3712)
    return '010-' + phone;
  }
  
  // 그 외의 경우는 원본을 반환하거나, 추가적인 규칙을 적용할 수 있습니다.
  return phone;
};
